import React, { Component, useEffect, useState } from "react";
import "./App.css";
import { Link, Redirect, useHistory } from "react-router-dom";
import Axios from "axios";
import ReactTooltip from "react-tooltip";
import QrReader from "react-qr-scanner";
import Footer from "./components/Footer";
import {
  IoIosContact,
  IoIosCalendar,
  IoIosBarcode,
  IoIosCard,
  IoMdHeartEmpty,
  IoMdPerson,
  IoIosLock,
  IoIosPaper,
  IoIosInformationCircleOutline,
  IoIosLogOut,
  IoIosRemoveCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoIosPodium,
  IoMdPeople,
  IoIosPeople,
  IoIosAdd,
  IoIosAddCircleOutline,
  IoIosRefresh,
  IoIosArrowDown,
  IoIosArrowUp,
  IoMdPhonePortrait,
  IoLogoAndroid,
  IoLogoWindows,
  IoLogoChrome,
  IoLogoApple,
  IoIosBrowsers,
  IoIosSettings,
  IoIosCheckbox,
  IoIosCheckboxOutline,
  IoMdCheckbox,
  IoIosArrowBack,
} from "react-icons/io";
import {
  BsCalendar,
  BsPeople,
  BsBoundingBoxCircles,
  BsPerson,
  BsLock,
  BsPen,
  BsApp,
  BsAppIndicator,
  BsArrowRight,
  BsGraphUp,
  BsSearch,
} from "react-icons/bs";
import { BiCheckbox, BiDevices, BiEditAlt } from "react-icons/bi";
import { AiOutlineScan } from "react-icons/ai";
import {
  RiCalendarEventLine,
  RiCheckboxBlankFill,
  RiCheckboxBlankLine,
  RiCheckboxLine,
  RiMacbookLine,
} from "react-icons/ri";
import { FaEdge, FaSafari, FaFirefox, FaLinux } from "react-icons/fa";

import Header from "./components/HeaderCampaign";
import Switch from "react-switch";
// import HorizontalScroller from "react-horizontal-scroll-container";
import TopBarProgress from "react-topbar-progress-indicator";
import Header3 from "./components/Header3";
import {
  IoBrowsers,
  IoBrowsersSharp,
  IoCheckbox,
  IoCheckboxOutline,
  IoCheckboxSharp,
  IoPhonePortrait,
} from "react-icons/io5";
import Header5 from "./components/Header5";
import { Dropdown } from "react-bootstrap";
import FullPayoutModal from "./modals/payouts/RequestPayoutModal";
import PayoutRequestList from "./components/payouts/PayoutRequestList";

const MyRecruits = (Props) => {
  const history = useHistory();
  const [refreshing, setRefreshing] = useState(false);
  const [query, setQuery] = useState("");
  const [password, setPassword] = useState("");
  const [response, setResponse] = useState("");
  const [error, setError] = useState("");
  const [errorDisplay, setErrorDisplay] = useState("d-none");
  const [details, setDetails] = useState([]);
  const [events, setEvents] = useState([]);
  const [queryResults, setQueryResults] = useState([]);
  const [customerlist, setCustomerlist] = useState([]);
  const [platformlist, setPlatformlist] = useState([]);
  const [numberOfclientes, setNumberOfclientes] = useState(0);
  const [numberOfbooster, setNumberOfbooster] = useState(0);
  const [numberOfboosterDeactivated, setNumberOfboosterDeactivated] =
    useState(0);
  const [delay, setDelay] = useState(100);
  const [result, setResult] = useState("No result");
  const [loadBarProgress, setLoadBarProgress] = useState(true);
  const [refreshingText, setRefreshingText] = useState(false);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [loadCustomers, setLoadCustomers] = useState(false);
  const [loadingPlatforms, setLoadingPlatforms] = useState(false);
  const [newcampaignbutton, setNewcampaignbutton] = useState(
    "new-campaign-button"
  );
  const [customers, setCustomers] = useState("new-campaign-button");
  const [platforms, setPlatforms] = useState("new-campaign-button");
  const [tick, setTick] = useState(0);
  const [count, setCount] = useState(0);
  const [countU, setCountU] = useState(0);
  const [loadIndi, setLoadIndi] = useState(false);
  const [loadIndiBlank, setLoadIndiBlank] = useState(true);
  const [allselected, setAllselected] = useState(0);
  const [campaignCount, setCampaignCount] = useState(0);
  const [loadSearchBox, setLoadSearchBox] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [loadSearchresults, setLoadSearchresults] = useState(false);
  const [enddate, setEnddate] = useState("");
  const [eventdate, setEventdate] = useState("");
  const [eventid, setEventid] = useState("");
  const [eventname, setEventname] = useState("");
  const [poster, setPoster] = useState("");
  const [event_date, setEvent_date] = useState("");
  const [finish_date, setFinish_date] = useState("");
  const [theme, setTheme] = useState("");
  const [venue, setVenue] = useState("");
  const [expectednum, setExpectednum] = useState("");
  const [time, setTime] = useState("");
  const [endtime, setEndtime] = useState("");
  const [open, setOpen] = useState(false);
  const [campaignid, setCampaignid] = useState("");
  const [openLogo, setOpenLogo] = useState(false);
  const [arrowIcon, setArrowIcon] = useState(false);
  const [campaignname, setCampaignname] = useState("");
  const [balance, setBalance] = useState(0);
  const [alertType, setAlertType] = useState("error-login");
  const [payOutType, setPayOutType] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [clipLoading, setClipLoading] = useState(false);
  const [confirmBtn, setConfirmBtn] = useState("save-btn text-bold");
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [alertState, setAlertState] = useState("success-alert");
  const [resMessage, setResMessage] = React.useState("");
  const [partnerId, setPartnerId] = useState(0);
  const [netPayout, setNetPayout] = useState(0);

  const [totalEarnings, setTotalEarnings] = useState(0);
  const [eligibleEarnings, setEligibleEarnings] = useState(0);
  const [isEligible, setIsEligible] = useState(0);

  useEffect(() => {
    const businessname = localStorage.getItem("businessname");
    const accounttype = localStorage.getItem("accounttype");
    const partnerid = localStorage.getItem("businessid");
    document.title = "Affiliate Campaign Overview";

    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=RECRUITS-CAMPAIGNS`,
      { withCredentials: true }
    )
      .then((response) => {
        setRefreshingText(false);
        if (response.data.status === "failed") {
          setDetails([]);
        } else {
          setDetails(response.data);
        }
        setLoadBarProgress(false);
      })
      .catch((error) => console.log(error));

    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=PARTNERDETAILS`,
      { withCredentials: true }
    )
      .then((response) => {
        setPartnerId(response.data.partnerid);

        fetchPayoutAmount(response.data.partnerid);
      })
      .catch((error) => console.log(error));
  }, [countU]);

  const fetchPayoutAmount = (partnerId) => {
    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=PARTNER-PAYOUT-AMOUNT&partner_id=${partnerId}`,
      { withCredentials: true }
    )
      .then((response) => {
        setNetPayout(response.data.payout);
        setTotalEarnings(response.data.totalEarnings ?? 0);
        // setEligibleEarnings(response.data.eligibleEarnings);
        setEligibleEarnings(response.data.availableEarnings ?? 0);
        setIsEligible(response.data.isEligible);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const refresh = () => {
    setLoadBarProgress(true);
    setRefreshingText(true);
    setCountU(countU + 1);
    // setTimeout(() => {
    //   setLoadBarProgress(false);
    // setRefreshingText(false);
    // }, 3000);

    // history.push("/campaigns");
  };

  const newCampaign = () => {
    setLoadCustomers(false);
    setCustomers("new-campaign-button");
    setPlatforms("new-campaign-button");
    setLoadingPlatforms(false);

    if (loadingEvents == true) {
      setLoadingEvents(false);
      setNewcampaignbutton("new-campaign-button");
    } else {
      setLoadingEvents(true);
      setNewcampaignbutton("new-campaign-button-active");
    }
  };

  const detailsF = () => {
    let activeString = "";
    const accountid = localStorage.getItem("businessid");
    const businessname = localStorage.getItem("businessname");
    const accounttype = localStorage.getItem("accounttype");
    let { event, poster, nb } = "";

    let currentDate = new Date();
    let month = "";
    let date = "";
    if (currentDate.getMonth() <= 9) {
      month = "0" + (currentDate.getMonth() + 1);
    } else {
      month = currentDate.getMonth() + 1;
    }

    if (currentDate.getDate() <= 9) {
      date = "0" + currentDate.getDate();
    } else {
      date = currentDate.getDate();
    }

    let curDate = currentDate.getFullYear() + "-" + month + "-" + date;

    let { string, campaignname, boolean, remainingBalance, campaignid } = "";

    const style = open ? { display: "none" } : {};
    const logoStyle = openLogo ? { display: "none" } : {};
    const arrowIconStyle = arrowIcon ? { display: "none" } : {};

    const year = currentDate.getFullYear();
    const fulldate = year + "-" + month + "-" + date;

    const parseCurrency = (value) => {
      const cleaned = (value || "0").replace(/,/g, "");
      const parsed = parseFloat(cleaned);
      return isNaN(parsed) ? 0 : parsed;
    };

    return (
      <div className="vertical-scroll">
        <table width="100%" className="table table-striped table-bordered">
          <tr>
            <td width={"5%"} className="text-center">
              <span>Poster</span>
            </td>
            <td width={"10%"}>
              <label
                data-tip="Event associated with this campaign"
                data-effect="solid"
              >
                <span>Event</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={"7%"}>
              <label
                data-tip="Indicates whether the event is currently live, upcoming, expired, or paused. This helps you track which events are actively visible and promotable."
                data-effect="solid"
              >
                <span>Status</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={"5%"} className="text-left">
              <label
                data-tip="Organisers who registered on Karamale through your referral link. These signups are attributed to your affiliate activity."
                data-effect="solid"
              >
                <span>Referrals</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={"10%"}>
              <label
                data-tip="Keywords used to promote the event (useful for search)"
                data-effect="solid"
              >
                <span>Keywords</span>
                <ReactTooltip />
              </label>
            </td>

            {/* <td width={"10%"}>
              <label
                data-tip="Name of the campaign"
                data-effect="solid"
                className=""
              >
                <span>Campaign</span>
                <ReactTooltip />
              </label>
            </td> */}

            <td width={"10%"}>
              <label
                data-tip="Marks the start of the public listing period for this event. Used to calculate visibility duration and affiliate activity."
                data-effect="solid"
              >
                <span>Visibility Start Date</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={"10%"} className="hide-border">
              <label
                data-tip="This is the final date the event will remain publicly listed and eligible for affiliate promotion. After this, it will no longer be visible to buyers."
                data-effect="solid"
              >
                <span>Visibility End Date</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={"10%"}>
              <label
                data-tip="This is the period during which the event is publicly accessible and can be promoted by affiliates."
                data-effect="solid"
              >
                <span>Event Listing Period</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={"10%"}>
              <label
                data-tip="This reflects how many days remain before the event is no longer visible to the public."
                data-effect="solid"
              >
                <span>Days remaining</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={"10%"}>
              <label
                data-tip="The date when the event will take place. This is important for planning and scheduling purposes."
                data-effect="solid"
              >
                <span>Event date</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={"7%"}>
              <label
                data-tip="Total number of times the event page was opened, including repeat visits by the same user."
                data-effect="solid"
              >
                <span>Views</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={"7%"}>
              <label
                data-tip="Number of distinct users who viewed the event, counted once per session or login."
                data-effect="solid"
              >
                <span>Unique visitors</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={"5%"}>
              <label
                data-tip="Total number of interactions, including repeat clicks by the same user."
                data-effect="solid"
              >
                <span>Clicks</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={"5%"}>
              <label
                data-tip="Number of distinct users who clicked, counted only once per user."
                data-effect="solid"
              >
                <span>Unique clicks</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={"8%"}>
              <label
                data-tip="Admissions are the total number of people who are likely to attend the event based on ticket sales. This metric helps you gauge the expected turnout."
                data-effect="solid"
              >
                <span>Admissions</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={"8%"}>
              <label
                data-tip="Unique buyers are the number of distinct individuals who have purchased tickets for this event. This metric helps you understand the reach of your campaign."
                data-effect="solid"
              >
                <span>Unique buyers</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={"10%"} className="hide-border">
              <label
                data-tip="Shows earnings per each event"
                data-effect="solid"
              >
                <span>Earnings</span>
                <ReactTooltip />
              </label>
            </td>

            <td width={"10%"} className="hide-border">
              <label
                data-tip="Indicates if ticket refunds are allowed."
                data-effect="solid"
              >
                <span>Refunds Allowed</span>
                <ReactTooltip />
              </label>
            </td>
            <td width={"10%"} className="hide-border">
              <label
                data-tip="Refundable events are not eligible for payout until the event is complete and all refunds are reconciled."
                data-effect="solid"
              >
                <span>Payout Eligibility</span>
                <ReactTooltip />
              </label>
            </td>
          </tr>

          {details.length < 1 ? (
            <tr>
              <td colSpan={25}>
                <div className="w-100 text-left">
                  <label className="text-14 text-grey">
                    <span className="text-black">No Events Yet</span>
                    <br />
                    There are currently no active events linked to your account.
                    Once organisers go live, you'll be able to track
                    performance, engagement, and potential earnings here.
                  </label>
                </div>
              </td>
            </tr>
          ) : (
            details.map((item, index) => {
              let tempEventname = item.eventname;
              const passEventname = tempEventname;
              const campaignstatus = item.campaignstatus;
              let budget = item.budget;
              let ticketset = item.ticketid;
              let markticketset = "";
              let inCheckmark = "";
              let thumbnail = item.thumbnail;
              let pausebtn = "";
              remainingBalance = item.balance;
              campaignid = item.campaignid;

              const digital = parseCurrency(item.digitalRevenue);
              const physical = parseCurrency(item.physicalRevenue);
              const total = digital + physical;

              const feesDeducted = (
                Number(item.feesDeductedPhysical) +
                Number(item.feesDeductedDigital)
              ).toFixed(2);

              const currentBudget = item.budget;

              const amountClean = parseFloat(currentBudget.replace(/,/g, ""));
              const feeClean = parseFloat(feesDeducted.replace(/,/g, ""));

              const currentBalance = Number(amountClean) - Number(feeClean);

              const formattedCurrentBalance = currentBalance.toLocaleString(
                "en-ZA",
                {
                  style: "currency",
                  currency: "ZAR",
                }
              );
              {
                item.activation == 1
                  ? (activeString = (
                      <IoIosCheckmarkCircleOutline size={18} color="green" />
                    ))
                  : (activeString = (
                      <IoIosRemoveCircleOutline size={18} color="red" />
                    ));
              }

              {
                item.campaignname.length > 25
                  ? (campaignname = item.campaignname.substring(0, 25) + "...")
                  : (campaignname = item.campaignname);
              }

              if (
                item.thumbnail.trim() === "" ||
                item.thumbnail.trim() === "none"
              ) {
                poster = "https://karamale.com/apps/kscanner/placeholder.png";
                nb = (
                  <label
                    data-tip="Complete event setup"
                    className="float-right"
                    style={{ color: "red", float: "right", fontWeight: 400 }}
                  >
                    <ReactTooltip />
                    <BiEditAlt />
                  </label>
                );
              } else {
                nb = "";
                poster =
                  "https://karamale.com/apps/kscanner/posters/" +
                  item.businessid +
                  "/" +
                  item.eventid +
                  "/" +
                  item.thumbnail;
              }

              if (item.campaignstatus == "running") {
                boolean = true;
              } else {
                boolean = false;
              }
              return (
                <tr className="">
                  <td className="text-center">
                    <label
                      style={{
                        backgroundImage: `url(` + poster + `)`,
                        width: 49,
                        height: 49,
                        borderRadius: 100,
                        backgroundSize: "100%",
                      }}
                    ></label>
                  </td>
                  <td>
                    <label className="w-100">{item.eventname}</label>
                  </td>

                  <td>
                    {item.campaignstatus == "running" ? (
                      <label style={{ color: "#4ca64c" }}>Running</label>
                    ) : (
                      <>
                        {item.daysRemaining == "---" ? (
                          <label style={{ color: "red" }}>Ended</label>
                        ) : (
                          <label style={{ color: "silver" }}>
                            Paused/Not started
                          </label>
                        )}
                      </>
                    )}
                  </td>
                  <td className="text-left">
                    <label className="widgets">{item.organiser_name}</label>
                  </td>
                  <td>{item.keywords}</td>

                  <td>{item.fromdate}</td>
                  <td>{item.todate}</td>

                  {/* <td>{campaignname}</td> */}

                  <td>{item.getPeriod} days</td>
                  <td>
                    {item.daysRemaining}{" "}
                    {item.daysRemaining == "---"
                      ? ""
                      : item.daysRemaining == 1
                      ? "day"
                      : "days"}
                  </td>

                  <td>{item.eventday}</td>
                  <td>{item.views}</td>
                  <td>{item.unique_visitors}</td>
                  <td>{item.eventClicks}</td>
                  <td>{item.unique_clicks}</td>
                  <td>{item.admission ?? 0}</td>
                  <td>{item.buyers ?? 0}</td>
                  <td>R{item.affiliateEarnings}</td>
                  <td>{item.refunds_allowed == 0 ? "No" : "Yes"}</td>

                  <td>
                    {item.refunds_allowed == 0
                      ? "Eligible for payout"
                      : "Not eligible for payout"}
                  </td>
                </tr>
              );
            })
          )}
        </table>
      </div>
    );
  };

  const closeError = () => {
    setErrorDisplay("none");
  };

  const handleSearch = async (event, campaign_id) => {
    // alert(campaignid);
    setSearchValue(event.target.value);
    const businessid = localStorage.getItem("businessid");
    const searchVal = event.target.value;
    const formData = new FormData();
    formData.append("search", event.target.value);

    await Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=SEARCHEVENTS&search=" +
        searchVal +
        "&businessid=" +
        businessid +
        "&campaignid=" +
        campaign_id,
      {
        withCredentials: true,
      }
    ).then((response) => {
      if (response.data.val == 0) {
        setQueryResults([]);
      } else {
        setQueryResults(response.data);
      }
    });

    if (!searchVal) {
      setLoadSearchresults(false);
    } else {
      setLoadSearchresults(true);
    }
  };

  if (localStorage.getItem("partnerid") === null) {
    return <Redirect to="/login" />;
    //   return exit(1);
  } else {
  }
  const businessname = localStorage.getItem("businessname");
  const businessid = localStorage.getItem("businessid");
  const accounttype = localStorage.getItem("accounttype");

  const previewStyle = {
    height: 240,
    width: 320,
    border: "thin solid red",
  };

  let activeEdit = "";

  if (count == 1) {
    activeEdit = "";
  } else {
    activeEdit = "button-disabled";
  }

  const requestPayout = (type) => {
    setPayOutType(type);
    setModalOpen(true);
  };

  const handlePayoutRequest = (amountRequested) => {
    const numericAmount = Number(amountRequested).toFixed(2);
    if (!numericAmount || numericAmount <= 0) {
      setAlertState("error-alert");
      setResMessage("Enter a valid amount");
      setErrorDisplay("d-block");
      setModalOpen(false);
      setTimeout(() => {
        setErrorDisplay("d-none");
      }, 5000);
      return; // optional validation
    }
    if (numericAmount > eligibleEarnings) {
      setAlertState("error-alert");
      setResMessage("Amount cannot exceed Available amount");
      setErrorDisplay("d-block");
      setModalOpen(false);
      setTimeout(() => {
        setErrorDisplay("d-none");
      }, 5000);

      return;
    }

    const data = new FormData();
    data.append("amountRequested", numericAmount);
    data.append("partner_id", partnerId);
    data.append("payout_type", payOutType);
    data.append("source", "PARTNER_PAYOUT");
    data.append("query", "AFFILIATE-REQUEST-PAYOUT");
    setClipLoading(true);
    setConfirmBtn("btn-disabled text-bold");
    setDisabledBtn(true);

    Axios({
      method: "POST",
      url: "https://karamale.com/apps/kscanner/webservices.php",
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        setCount(count + 1);
        const responseData = response.data;
        console.log(responseData.status);
        if (responseData.status === "success") {
          setCountU(countU + 1);
          setResMessage(responseData.message);
          setAlertState("success-alert");
          setErrorDisplay("d-block");
          setModalOpen(false);

          setTimeout(() => {
            setErrorDisplay("d-none");
          }, 5000);
        } else {
          setAlertState("error-alert");
          setResMessage(responseData.message);
          setErrorDisplay("d-block");
          setModalOpen(false);
          setTimeout(() => {
            setErrorDisplay("d-none");
          }, 5000);
        }

        setClipLoading(false);
        setConfirmBtn("save-btn text-bold");
        setDisabledBtn(false);
      })
      .catch((error) => {
        setClipLoading(false);
        setConfirmBtn("save-btn text-bold");
        setDisabledBtn(false);
        console.log(error);
      });
  };
  return (
    <div className="events-dashboard p-3">
      <div className="dashboard-header">
        <h5 className="dashboard-title mt-2">Dashboard</h5>
      </div>
      <div className="row w-100 align-items-center justify-content-center just-container-insid mt-3">
        <div className="col-12 p-0 d-flex justify-content-start justify-content-lg-end">
          <button type="button" className="totat_earnings mb-0">
            Gross: R{totalEarnings}
          </button>
          <Dropdown className="mb-2">
            <Dropdown.Toggle
              variant={
                eligibleEarnings <= 0 || isEligible == 0 ? "disabled" : "info"
              }
              id="dropdown-basic"
              className="text-bold"
              disabled={eligibleEarnings <= 0 || isEligible == 0 ? true : false}
            >
              Available: R{eligibleEarnings}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => requestPayout("partial")}
                className="text-decoration-none"
              >
                Partial payout
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => requestPayout("full")}
                className="text-decoration-none"
              >
                Full payout - R{eligibleEarnings}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <FullPayoutModal
            isOpen={modalOpen}
            onClose={() => setModalOpen(false)}
            onConfirm={handlePayoutRequest}
            netPayout={eligibleEarnings}
            payOutType={payOutType}
            clipLoading={clipLoading}
            confirmBtn={confirmBtn}
            disabledBtn={disabledBtn}
            count={count}
            source={"partnerPayout"}
          />
        </div>
        <div className="col-12 p-0">
          <label className="alert alert-info p-2">
            <span>How Payout Eligibility Works</span>
            <br />
            Your <span>Gross earnings</span> reflect all commission earned —
            including from events still pending or refundable. Your{" "}
            <span>Available earnings</span> are payout-ready once they reach
            R250+ and meet all eligibility criteria. For events that allow
            refunds, earnings only become Available after the event ends and all
            refunds are reconciled — ensuring payouts reflect final,
            irreversible commission.
          </label>
        </div>
        <div className=" BoxDashboardContainer mb-4 pb-3  pl-3 pr-3">
          <div className="">
            <div className="row w-100 align-items-center top-data-taps">
              <div className="col-12 p-0">
                <PayoutRequestList
                  eventid={partnerId}
                  count={count}
                  setRefreshing={setRefreshing}
                  source={"partnerPayout"}
                />
              </div>
              <div className="col-6 p-0">
                <span>Linked Events</span>
              </div>

              <div className="col-6 text-right p-0">
                {refreshingText && (
                  <label className="refreshing-text">Refreshing...</label>
                )}
                &nbsp; &nbsp;
                <label
                  className="refresh-icon"
                  data-tip="Refresh"
                  onClick={() => refresh()}
                  style={{ marginRight: -2 }}
                >
                  <IoIosRefresh size={20} />
                  <ReactTooltip />
                </label>
              </div>
            </div>
          </div>
          {detailsF()}
        </div>
      </div>

      <div className={alertState + " text-center " + errorDisplay}>
        {resMessage}
      </div>
    </div>
  );
};

export default MyRecruits;
